"use strict";

module.exports = {
  "ada_back": "retroceder",
  "ada_cancel": "Cancelar",
  "ada_close_modal": "cerrar",
  "ada_escape_to_close": "Presiona escape para cerrar",
  "ada_favorite": "Favorito",
  "ada_find_enter_to_select": "Presiona enter para seleccionar",
  "ada_find_filter_freestyle": "Coca-cola Freestyle",
  "ada_find_search": "Buscar",
  "ada_find_search_enter": "Presiona enter para buscar",
  "ada_find_search_text": "Pon la ciudad y el estado o el código postal para encontrar una ubicación de Wendy's",
  "ada_find_search_your_location": "Buscar restaurantes Wendy’s cerca de tu ubicación",
  "ada_kilometers": "Kilómetros",
  "ada_limited_time_offer": "Oferta solo por tiempo limitado",
  "ada_miles": "Millas",
  "ada_space_to_toggle": "Presiona space para cambiar",
  "amenities_always_open": "Abierto las 24 Horas",
  "amenities_breakfast": "Desayuno",
  "amenities_freestyle": "Coca-Cola Freestyle©",
  "amenities_mobile_order": "Pedidos por celular",
  "amenities_mobile_pay": "Pagos por celular",
  "amenities_open_late": "Abierto hasta tarde",
  "amenities_wifi": "Wi-Fi",
  "card_hours_open": "Abierto: ",
  "common_login_and": "y",
  "common_login_cookies": "Política sobre cookies - Tecnologías de seguimiento",
  "common_login_does_not_match": "No coincide",
  "common_login_dont_have": "¿No tienes una cuenta?",
  "common_login_email_address": "Dirección de correo electrónico",
  "common_login_email_placeholder": "Iniciar sesión como",
  "common_login_email_verification_message": "Correo electrónico confirmado. ¡Magnífico! Inicia sesión para encontrar algo delicioso.",
  "common_login_forgot_password": "¿Olvidaste la contraseña",
  "common_login_invalid_email": "Correo electrónico inválido",
  "common_login_login_with": "Iniciar sesión con",
  "common_login_name_email_error": "El correo electrónico y la contraseña no coinciden. Vuelve a intentarlo.",
  "common_login_privacy_policy": "Política De Privacidad",
  "common_login_read_our": "Lee nuestros",
  "common_login_required": "Obligatorio",
  "common_login_reset": "Restablecer",
  "common_login_reset_message": "Restablecer la contraseña para la cuenta de Wendy’s®",
  "common_login_reset_password": "Contraseña restablecida",
  "common_login_show_all": "Mostrar todas las opciones de inicio de sesión",
  "common_login_show_options": "Mostrar todas las opciones de inicio de sesión",
  "common_login_sign_up": "Inscríbase",
  "common_login_submit_button": "Enviar",
  "common_login_terms_of": "Términos de Uso",
  "common_login_title": "Iniciar Sesión",
  "common_login_welcome_back": "Bienvenido nuevamente",
  "common_login_with": "O iniciar sesión con",
  "comp_LoginModal_ContinueAsGuest": "Continuar como invitado",
  "comp_LoginModal_CreateAccount_ContinueAsGuest": "Continuar como invitado",
  "comp_LoginModal_CreateAccount_Email_placeholder": "Correo electrónico",
  "comp_LoginModal_CreateAccount_FirstName_placeholder": "Nombre",
  "comp_LoginModal_CreateAccount_LastName_placeholder": "Apellido",
  "comp_LoginModal_CreateAccount_OptIn": "Me gustaría recibir ofertas de Wendy's de vez en cuando.",
  "comp_LoginModal_CreateAccount_Password_placeholder": "Contraseña",
  "comp_LoginModal_CreateAccount_RegistryWith": "o registrarse con",
  "comp_LoginModal_CreateAccount_SecurityQuestionAnswer_placeholder": "Respuesta a la pregunta de seguridad",
  "comp_LoginModal_CreateAccount_Signup_button": "Suscribirse",
  "comp_LoginModal_CreateAccount_SubText": "Ingresa los detalles para crear una cuenta digital Wendy’s®.",
  "comp_LoginModal_CreateAccount_SubText_Loyalty": "Ingresa los detalles para crear una cuenta digital Wendy’s®, luego inscríbete en Wendy’s Rewards™.",
  "comp_LoginModal_CreateAccount_TOC": "Términos de Uso",
  "comp_LoginModal_CreateAccount_TOC_first": "Lea nuestros",
  "comp_LoginModal_CreateAccount_TOS": "Términos de Servicio",
  "comp_LoginModal_CreateAccount_TOS_first": "Acepto los",
  "comp_LoginModal_Email_placeholder": "Introducir correo electrónico",
  "comp_LoginModal_ForgotPassword": "¿Olvidó la contraseña?",
  "comp_LoginModal_Login_button": "Iniciar sesión",
  "comp_LoginModal_OrLoginWith": "o iniciar sesión con",
  "comp_LoginModal_Password_placeholder": "Contraseña",
  "comp_LoginModal_createAccount_button": "Crear cuenta",
  "comp_LoginModal_forgotPassword_cancel_button": "Cancelar",
  "comp_LoginModal_forgotPassword_email_address_placeholder": "Dirección de correo electrónico",
  "comp_LoginModal_forgotPassword_first_step_description": "Introduzca su correo electrónico en el campo que aparece a continuación y haga clic en \"Enviar\".",
  "comp_LoginModal_forgotPassword_header": "Olvidó la contraseña",
  "comp_LoginModal_forgotPassword_securityQuestion_description": "Responda la pregunta de seguridad que aparece a continuación y haga clic en \"Restablecer\".",
  "comp_LoginModal_forgotPassword_securityQuestion_done_button": "Restablecer",
  "comp_LoginModal_forgotPassword_securityQuestion_input_placeholder": "Respuesta a la pregunta de seguridad",
  "comp_LoginModal_forgotPassword_submit_button": "Enviar",
  "comp_LoginModal_header": "Iniciar sesión o crear una cuenta",
  "comp_LoginModal_login_button": "Iniciar sesión",
  "easy_as": "Tan fácil como",
  "email_sign_up": "Inscríbase",
  "email_sign_up_confirm_password": "Confirmar contraseña",
  "email_sign_up_does_not_match": "No Coincide",
  "email_sign_up_email_address": "Dirección de correo electrónico",
  "email_sign_up_first_name": "Nombre",
  "email_sign_up_invalid_postal": "Código postal inválido",
  "email_sign_up_last_name": "Apellido",
  "email_sign_up_need_info": "Solo necesitamos un par de cosas más para registrar tu cuenta.",
  "email_sign_up_need_info_loyalty": "Ingresa los detalles para crear una cuenta digital Wendy’s, luego inscríbete en Recompensas Wendy’s.",
  "email_sign_up_need_postal": "Comparte tu código postal para asegurarte de no perderte cosas increíbles",
  "email_sign_up_page_title": "Inicia sesión con el correo electrónico",
  "email_sign_up_password": "Contraseña",
  "email_sign_up_postal_code": "Código postal",
  "email_sign_up_zip_code": "Código postal",
  "email_sign_up_security_question": "Pregunta de seguridad",
  "email_sign_up_security_question_answer": "Respuesta a la Pregunta de seguridad",
  "email_sign_up_select_security_question": "Selecciona una Pregunta de seguridad",
  "email_sign_up_zip_desc": "Esto nos sirve para enviarte las ofertas y los artículos destacados exclusivos para tu área.",
  "email_sign_up_submit_error": "Todos los campos son obligatorios.",
  "email_sign_up_country": "País",
  "email_sign_up_currency": "Moneda",
  "email_sign_up_country_description": "Determina qué alimentos del menú se deben mostrar y cómo dar formato al texto.",
  "email_sign_up_currency_description": "Configura la moneda de tu cuenta digital de modo permanente.",
  "email_terms_text1": "Al hacer clic en “Inscríbase” aceptas los ",
  "flag_selector_title": "Inicia sesión con el correo electrónico",
  "flag_selector_description": "Escoge tu país. Esto nos indica qué artículos del menú mostrarte y cómo formatear al texto según tu país.",
  "flag_selector_us_flag": { id: 1, value: "Estados Unidos", postValue: 'US' },
  "flag_selector_ca_flag": { id: 2, value: "Canadá", postValue: 'CA' },
  "email_verification_step1_title_1": "Busque ",
  "email_verification_step1_title_2": "un mensaje de Wendy's ",
  "email_verification_step1_title_3": "en su correo electrónico.",
  "email_verification_step2_title_1": "Haga clic ",
  "email_verification_step2_title_2": "en el botón ",
  "email_verification_step2_title_3": "para confirmar su dirección de correo electrónico.",
  "email_verification_title": "Ya casi termina. Solo un par de cosas más...",
  "find_buttons_get_directions": "Ver direcciones",
  "find_buttons_select": "Seleccionar",
  "footer_about_us": "Sobre nosotros",
  "footer_bottom_contact": "CONTACTO",
  "footer_buy_cards": "Tarjetas de regalo",
  "footer_careers": "Empleos",
  "footer_check_card_balance": "Consulta del Saldo de Tarjeta",
  "footer_community": "COMUNIDAD",
  "footer_contact": "Contacto",
  "footer_cookie": "Política Sobre Coookies Y Technologías De Seguimiento",
  "footer_copyright": "© 2017 Quality Is Our Recipe, LLC",
  "footer_dave_thomas_foundation": "Fundación Dave Thomas para la Adopción",
  "footer_get_app": "OBTENER MI APP DE WENDY'S",
  "footer_international": "Internacional",
  "footer_investors": "Inversores",
  "footer_locations": "Ubicaciones",
  "footer_mailing_address": "One Dave Thomas Boulevard, Dublin, OH 43017",
  "footer_news": "Noticias",
  "footer_nutrition_information": "Información nutricional",
  "footer_our_company": "NUESTRA COMPAÑÍA",
  "footer_payment_incident": "Actualizaciones de los incidentes con las tarjetas de pago",
  "footer_privacy": "Política De Privacidad",
  "footer_quick_links": "ENLACES RÁPIDOS",
  "footer_responsibility": "Responsabilidad",
  "footer_sign_up_for_my_wendys": "Suscríbete a WendyMail™",
  "footer_sitemap": "MAPA DEL SITIO",
  "footer_stay_connected": "PERMANECE CONECTADO",
  "footer_terms": "Términos De Uso",
  "footer_unsubscribe": "Cancelar suscripción",
  "footer_wendys_gives_back": "Wendy’s® Retribuye",
  "footer_wendys_high_school_heisman": "Wendy's® High School Heisman®",
  "footer_wendys_wonderful_kids": "Wendy's Wonderful Kids®",
  "header_about_us": "SOBRE NOSOTROS",
  "header_careers": "EMPLEOS",
  "header_feedback": "COMENTARIOS",
  "header_menu_image_1": "/images/nav/es_US/dine-men-1.png",
  "header_menu_image_2": "/images/nav/es_US/dine-men-2.png",
  "header_menu_image_3": "/images/nav/es_US/dine-men-3.png",
  "header_menu_image_4": "/images/nav/es_US/dine-men-4.png",
  "header_menu_image_5": "/images/nav/es_US/dine-men-5.png",
  "header_menu_image_6": "/images/nav/es_US/dine-men-6.png",
  "header_menu_image_7": "/images/nav/es_US/dine-men-7.png",
  "header_menu_image_8": "/images/nav/es_US/dine-men-8.png",
  "header_menu_image_cta": "/images/nav/es_US/dine-men-cta.jpeg",
  "header_menu_link_1": "https://www.wendys.com/es-us/hamburgers",
  "header_menu_link_2": "https://www.wendys.com/es-us/chicken",
  "header_menu_link_3": "https://www.wendys.com/es-us/salads",
  "header_menu_link_4": "https://www.wendys.com/es-us/right-price-right-size",
  "header_menu_link_5": "https://www.wendys.com/es-us/fries-sides",
  "header_menu_link_6": "https://www.wendys.com/es-us/beverages",
  "header_menu_link_7": "https://www.wendys.com/es-us/kids-meals",
  "header_menu_link_8": "https://www.wendys.com/es-us/frosty",
  "header_menu_link_cta": "https://www.wendys.com/es-us/breakfast",
  "header_menu_text_1": "CHEESEBURGERS",
  "header_menu_text_2": "POLLO Y WRAPS",
  "header_menu_text_3": "ENSALADAS RICIÉN HECHAS",
  "header_menu_text_4": "RIGHT PRICE RIGHT SIZE MENU®",
  "header_menu_text_5": "PAPITAS Y ACOMPAÑAMIENTOS",
  "header_menu_text_6": "BEBIDAS",
  "header_menu_text_7": "WENDY'S KIDS MEAL®",
  "header_menu_text_8": "FROSTY®",
  "header_nav_learn_gift_card_link": "http://www.amazon.com/Wendys-20-Gift-Card/dp/B00P3DUFRW/ref=sr_1_6?ie=UTF8&qid=1417455051&sr=8-6&keywords=wendy",
  "header_nav_learn_meal_builder_link": "https://www.wendys.com/es-us/meal-builder",
  "header_nav_learn_meal_nutrition_link": "https://www.wendys.com/es-us/nutrition-info",
  "header_title_main_link": "/images/common/QIOR.es_US.png",
  "header_title_text_find": "ENCONTRAR",
  "header_title_text_learn": "CONOCER",
  "header_title_text_menu": "MENÚ",
  "header_title_text_my": "MI WENDY'S",
  "header_title_text_order": "ORDENAR",
  "header_title_text_play": "JUGAR",
  "language_select_canadian_english": "Inglés de Canadá",
  "language_select_canadian_french": "Francés de Canadá",
  "language_select_english": "Inglés de Estados Unidos",
  "language_select_spanish": "EE-UU",
  "location_page_filter_breakfast": "Desayuno",
  "location_page_filter_clear": "Borrar",
  "location_page_filter_coke_freestyle": "Coca-Cola Freestyle©",
  "location_page_filter_done": "Listo",
  "location_page_filter_is_favorite": "Favoritos",
  "location_page_filter_mobile_ordering": "Pedidos por celular",
  "location_page_filter_mobile_payment": "Pagos por celular",
  "location_page_filter_open_24_hours": "Abierto las 24 Horas",
  "location_page_filter_open_late": "Abierto hasta tarde",
  "location_page_filter_title": "Opciones de filtro",
  "location_page_filter_wifi": "Wi-Fi",
  "location_page_find_location_title": "Buscar una ubicación",
  "location_page_open_today": "Abierto",
  "maybe_later": "Omitir esto",
  "notification_geo_failed_text": "No pudimos obtener su ubicación. Introduzca su ubicación en el cuadro de búsqueda.",
  "notification_geo_failed_title": "Hubo un problema al obtener su ubicación",
  "notification_modal_failure_text": "Hubo un problema; vuelva a intentarlo más tarde.",
  "notification_modal_failure_title": "Hubo un problema",
  "notification_modal_success_text": "Agradecemos su interés en hacer pedidos online. Le informaremos cuando esta ubicación esté disponible para aceptar sus pedidos.",
  "notification_modal_success_title": "¡Gracias!",
  "notify_buttons_email_me": "Enviarme correo electrónico",
  "order_buttons_order_here": "Ordene Aqui",
  "payment_options_account_created": "Cuenta creada",
  "payment_options_add_card": "Agregar tarjeta",
  "payment_options_add_funds": "Agregar fondos",
  "payment_options_add_new_card": "Agregar una nueva tarjeta",
  "payment_options_are_you_sure_remove": "¿Seguro que desea eliminar esta tarjeta?",
  "payment_options_auto_reload": "Recarga automática",
  "payment_options_credit_card": "TARJETA DE CRÉDITO",
  "payment_options_curious_about_mobile": "¿Quiere saber más sobre los pagos por celular?",
  "payment_options_go_to_transaction_history": "Ir al historial de transacciones",
  "payment_options_grab_the_app_link_text": "Consiga la aplicación.",
  "payment_options_masked_credit_card": "terminando en",
  "payment_options_mobile_payment_app_explanation": "Puede realizar pagos por celular con la aplicación Mi Wendy's en determinadas ubicaciones participantes. Recuerde: su cuenta puede tener $100.00 como máximo",
  "payment_options_my_balance": "Mi saldo",
  "payment_options_no": "No",
  "payment_options_no_recent": "Sin actividad reciente",
  "payment_options_no_saved_card": "No hay ninguna tarjeta guardada",
  "payment_options_close": "Cerrar",
  "payment_options_payment_settings": "Configuración de pagos",
  "payment_options_recent_activity": "Actividad reciente",
  "payment_options_remove": "Eliminar",
  "payment_options_remove_your_card": "¿Desea eliminar su tarjeta?",
  "payment_options_replace": "Reemplazar",
  "payment_options_replace_card": "¿Reemplazar su tarjeta?",
  "payment_options_replace_card_explanation_text": "¿Seguro que desea reemplazar esta tarjeta? Si hace clic en \"Sí\", la tarjeta se eliminará de su cuenta, incluso si no completa el proceso de agregar una nueva.",
  "payment_options_wendys_digital_account": "CUENTA DIGITAL DE WENDY'S",
  "payment_options_yes": "Sí",
  "product_tile_selected": "Seleccionado",
  "promo_item_limited_time_offer": "LIMITED TIME OFFER",
  "rewards_back": "Atrás",
  "rewards_change": "Changer",
  "rewards_choose": "Elige",
  "rewards_choose_your_reward": "Elige tu Recompensa",
  "rewards_choose_your_reward_subtitle": "Gana la recompensa que quieres. Puedes cambiarla más tarde desde la página de cuenta.",
  "rewards_done_button": "Listo",
  "rewards_enrollment_disclaimer": "*Gratis con la inscripción completa para el programa de Recompensas de Wendy’s. Gana puntos y canjea tus recompensas solo en los pedidos por celular en los restaurantes Wendy’s® participantes. Puede tomar hasta 24 horas para que los puntos de recompensa se actualicen.",
  "rewards_free_single": "OBTIENE UNA DAVE’S SINGLE® GRATIS",
  "rewards_join_button": "Unirme a las Recompensas",
  "rewards_join_button_join": "Únete.",
  "rewards_join_choose_reward": "Elige tu Recompensa",
  "rewards_join_choose_reward_hint": "Elige la recompensa que deseas lograr. Puedes cambiar tu Recompensa en cualquier momento desde tu página de cuenta.",
  "rewards_join_coming_soon_body": "Espera un poco, todavía estamos perfeccionando la receta para que consigan Recompensas. Pero te enterarás primero en cuanto esté lista.",
  "rewards_join_coming_soon_title": "¡Pronto conseguirás Recompensas!",
  "rewards_join_loyalty_card_hint": "Si tienes una tarjeta de recompensa, ingresa el número aquí para confirmar tu identidad y agregaremos los puntos que hayas ganado en el restaurante.",
  "rewards_join_loyalty_card_label": "Ingresa tu número de tarjeta",
  "rewards_join_loyalty_card_placeholder": "Número en el reverso de la tarjeta",
  "rewards_join_loyalty_card_toggle_copy": "Recibí una tarjeta de recompensa en el restaurante.",
  "rewards_join_loyalty_card_toggle_hint": "¿No tienes una tarjeta? ¡Omite este paso!",
  "rewards_join_loyalty_card_toggle_label": "¿Tienes una tarjeta de recompensa?",
  "rewards_join_phone_hint": "Tu número de teléfono también es tu número de Wendy’s Rewards™.",
  "rewards_join_phone_label": "Ingresa tu número de teléfono",
  "rewards_join_phone_placeholder": "e.g. 123 456 7890",
  "rewards_join_postal_hint": "Recompensas está disponible en determinadas ubicaciones. Averigua si se ha lanzado en tu área.",
  "rewards_join_postal_label": "Ingresa tu código postal.",
  "rewards_join_postal_placeholder": "e.g. 23456",
  "rewards_join_title": "Únete a las Recompensas de Wendy",
  "rewards_join_value_prop": "Únete a las Recompensas de Wendy y gana 1 punto por cada dólar que gastes. Es simple.",
  "rewards_join_value_prop2": "Danos tu número de teléfono para completar tu inscripción en Recompensas.",
  "rewards_join_value_prop3": "Gana 1 punto por cada $1 que gastes",
  "rewards_join_value_prop4": "en los pedidos por celular en los restaurantes Wendy’s® participantes",
  "rewards_join_value_prop_available": "Inscríbete para empezar a acumular puntos.",
  "rewards_join_value_prop_step1": "Comida gratis a solo cinco dígitos de distancia.",
  "rewards_join_value_prop_unavailable": "Cosas gratis para los que esperan.",
  "rewards_join_value_prop_with_purchase": "con cualquier compra con tu próximo pedido por celular!",
  "rewards_join_wendymail_body": "Quiero recibir un WendyMail con la notificación del lanzamiento de las Recompensas en mi área,",
  "rewards_next_button": "Siguiente",
  "rewards_not_now": "Ahora no.",
  "rewards_one": "UNO",
  "rewards_one_text": "¡Únete a Recompensas, elije tu recompensa y disfruta un Dave’s Single®!",
  "rewards_points": "Puntos",
  "rewards_points_needed": "Puntos necesarios",
  "rewards_skip_button": "Omitir Recompensas",
  "rewards_step2_title": "Paso 2: ",
  "rewards_terms_and_conditions": "Términos y condiciones de recompensas.",
  "rewards_terms_and_conditions_preface": "Al marcar esta casilla, acepto los ",
  "rewards_three": "GRATIS",
  "rewards_three_text": "Tan pronto tengas suficientes puntos, te enviaremos tu recompensa. ¡No hay límite para la cantidad de recompensas que puedas ganar!",
  "rewards_three_title": "Recibe comida gratis",
  "rewards_two": "DOS",
  "rewards_two_text": "Todas las compras en Wendy’s te dan puntos para el objetivo de recompensas que elijas.",
  "rewards_two_title": "Gana puntos",
  "rewards_when_enroll": "cuando te suscribes.",
  "rewards_yours_now": "Es tuya ahora.",
  "search_container_mobile_pay": "Pagos por celular",
  "search_container_mobile_ordering": "Pedidos por celular",
  "search_container_breakfast": "Desayuno",
  "search_container_free_style": "Coca-Cola Freestyle©",
  "search_container_digital_coupon": "Cupón digital",
  "search_container_open_late": "Abierto hasta tarde",
  "search_container_24_hours": "Abierto las 24 Horas",
  "search_container_wifi": "Wifi",
  "search_container_hola": "Hola",
  "search_container_loyalty": "Loyalty",
  "search_container_mcx": "MCX",
  "search_container_cso": "CSO",
  "search_container_list": "Lista",
  "search_container_location_entry_placeholder": "Introduzca la ciudad, el estado o el código postal",
  "search_container_locations_found": "UBICACIONES ENCONTRADAS",
  "search_container_map": "Mapa",
  "search_container_no_results_message": "Ningún resultado, búsquedas sugeridas",
  "search_container_results_found": "Resultados encontrados",
  "search_container_search": "Buscar",
  "search_container_searching": "Buscando",
  "search_result_open": "Abierto",
  "search_results_no_loc": "No hay ningún restaurante Wendy’s en un área de 25 millas alrededor de tu ubicación.",
  "search_results_no_mobile_desc": "Es posible que los pedidos por celular no estén disponibles en tu área todavía, ¡pero no te quedes con hambre! Visita uno de nuestros restaurantes cercanos.",
  "search_results_on_our_way": "Vamos en camino.",
  "search_results_too_many_filters": "Necesitamos que elimines algunos filtros que casi satisfacen tu gusto exacto.",
  "selected_result_close": "Cerrar",
  "times_not_available": "Los tiempos no disponibles",
  "value_proposition_caption": "¿Quién tiene hambre?",
  "value_proposition_caption_img1_text_1": "Echa un vistazo a los nuevos alimentos",
  "value_proposition_caption_img1_text_2": "del menú de Wendy's",
  "value_proposition_caption_img2_text_1": "Obtén la información sobre",
  "value_proposition_caption_img2_text_2": "nutrición que necesitas",
  "value_proposition_caption_img3_text_1": "Inicia sesión y ahorra al elegir",
  "value_proposition_caption_img3_text_2": "tus alimentos favoritos",
  "value_proposition_login_text1": "Already have an account? ",
  "value_proposition_login_text2": "Iniciar Sesión",
  "value_proposition_sign_up_email": "Inicia sesión con tu correo electrónico",
  "value_proposition_sign_up_facebook": "Inicia sesión con Facebook",
  "value_proposition_sign_up_google": "Inicia sesión con Google",
  "delivery_search_title": "Get It Delivered",
  "delivery_search_body": "Get all your Wendy's favorites delivered right to your door.",
  "delivery_search_button": "Go to Delivery",
  "delivery_search_loading": "Cargando"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/localization/es_US.js
// module id = 190
// module chunks = 0